import { Action } from '@ngrx/store'
import * as MobileTasksTypes from './mobile-tasks.types'
import { MobileTask } from './mobile-tasks.interface'

// Fetch Users Actions
export class FetchMobileTasksRequest implements Action {
  readonly type = MobileTasksTypes.FETCH_MOBILE_TASKS_REQUEST
  constructor(public payload: any) {}
}

export class FetchMobileTasksSuccess implements Action {
  readonly type = MobileTasksTypes.FETCH_MOBILE_TASKS_SUCCESS
  constructor(
    public payload: MobileTask[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchMobileTasksFailure implements Action {
  readonly type = MobileTasksTypes.FETCH_MOBILE_TASKS_FAILURE
  constructor(public payload: any) {}
}

export class AutoAssignTasksRequest implements Action {
  readonly type = MobileTasksTypes.AUTOASSIGN_TASKS_REQUEST
  constructor(public userId?: any) {}
}

export class AutoAssignTasksSuccess implements Action {
  readonly type = MobileTasksTypes.AUTOASSIGN_TASKS_SUCCESS
  constructor(public payload: any) {}
}

export class AutoAssignTasksFailure implements Action {
  readonly type = MobileTasksTypes.AUTOASSIGN_TASKS_FAILURE
  constructor(public payload: any) {}
}

// Common Actions
export class UpdateField implements Action {
  readonly type = MobileTasksTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = MobileTasksTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchMobileTasksRequest
  | FetchMobileTasksSuccess
  | FetchMobileTasksFailure
  | AutoAssignTasksRequest
  | AutoAssignTasksSuccess
  | AutoAssignTasksFailure
